import { AssortmentDTO } from "../products/assortment.model";

export class AssortmentMultiSelectVM extends AssortmentDTO {
  checked: boolean;
  constructor(init?: AssortmentDTO) {
    super();
    Object.assign(this, init);
  }
}

